import PaymentService from "../../Services/PaymentService";

export const FETCH_USER_WALLETS_REQUEST = "FETCH_USER_WALLETS_REQUEST";
export const FETCH_USER_WALLETS_SUCCESS = "FETCH_USER_WALLETS_SUCCESS";
export const FETCH_USER_WALLETS_FAILURE = "FETCH_USER_WALLETS_FAILURE";


export const fetchUserWallets = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_USER_WALLETS_REQUEST });
    try {
        const response = await PaymentService.walletList(payload);
        dispatch({ type: FETCH_USER_WALLETS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_USER_WALLETS_FAILURE, payload: error.message });
    }
}
